import { ref, onMounted, onBeforeUnmount } from 'vue-demi';
import { isElementInViewport } from '../util';
import { FIXED_MODE } from '../constant';
const { throttle } = require('@futuweb/fego-bridge');

export function useHeaderFixed({ horizontalTabRef, props }) {
    const shouldFixed = ref(false);

    const checkShouldFixed = throttle(() => {
        const tabHeaderFake = horizontalTabRef.value.querySelector('.horizontal-anchor-tab-header-fake');
        const tabHeaderReal = horizontalTabRef.value.querySelector('.horizontal-anchor-tab-header-real');
        shouldFixed.value = !isElementInViewport(tabHeaderFake, 'entire');
        // 需要吸顶时，判断下吸顶模式
        if (shouldFixed.value && props.tpl?.props?.headerFixedMode === FIXED_MODE.IS_UPPER_VIEWPORT) {
            if (isElementInViewport(tabHeaderFake, 'below')) {
                shouldFixed.value = false;
            }
        }
        if (shouldFixed.value) {
            const height = tabHeaderReal.getBoundingClientRect().height;
            tabHeaderFake.style.height = height + 'px';
            tabHeaderReal.classList.add('horizontal-anchor-tab-fixed-header');
        } else {
            tabHeaderFake.style.height = 0 + 'px';
            tabHeaderReal.classList.remove('horizontal-anchor-tab-fixed-header');
        }
    }, 100);

    const watchScroll = () => {
        window.addEventListener('scroll', checkShouldFixed);
    };

    const unWatchScroll = () => {
        window.addEventListener('scroll', checkShouldFixed);
    };

    onMounted(() => {
        watchScroll();
        checkShouldFixed();
    });

    onBeforeUnmount(() => {
        unWatchScroll();
    });

    return {
        shouldFixed
    };
}
